import {connect} from 'react-redux'
import Log from '../components/log/Log'
import {RootState} from '../../common/redux/store'

const mapStateToProps = (state: RootState) => ({
  logEntryList: state.dashboard.logEntries,
})

export default connect(mapStateToProps)(Log)
